@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

@if (alertInfo.show) {
  <ngb-alert class="m-3" [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}

<form [formGroup]="form">
  <div class="row g-2 mb-2">
    <div class="col-md-6 col-lg-5 offset-lg-1">
      <div class="card h-100">
        <div class="card-header bg-light font-weight-bold">INTRODUCTION</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <select-field
                label="Category"
                [selectFormControl]="getFormControl('complaintCategoryId')"
                [options]="categoryOptions"
                [readonly]="false"
                />
            </div>
            <div class="col-md-6">
              <select-field
                label="Priority"
                [selectFormControl]="getFormControl('priority')"
                [options]="priorityOptions"
                [readonly]="false"
                />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-5">
      <div class="card h-100">
        <div class="card-header bg-light font-weight-bold">RESOLUTION</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <select-field
                label="Status"
                [selectFormControl]="getFormControl('status')"
                [options]="statusOptions"
                [readonly]="true"
                />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-12 col-lg-10 offset-1">
      <div class="card mb-0">
        <div class="card-header bg-light font-weight-bold">CUSTOMER</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Company</label>
                <input type="text" class="form-control" [value]="customerName" disabled style="background-color: #e9ecef; cursor: not-allowed;" />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label class="form-label">Customer Person</label>
                <input type="text" class="form-control" [value]="customerPersonName" disabled style="background-color: #e9ecef; cursor: not-allowed;" />
              </div>
            </div>
            <div class="col-md-1 d-flex align-items-end">
              <language-client
                [radioFormControl]="getFormControl('languageId')"
                [disabled]="true"
                [compactView]="true"
                />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row mb-2">
    <div class="col-md-12 col-lg-10 offset-1">
      <div class="card mb-0">
        <div class="card-header bg-light font-weight-bold">DETAILS</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <input-field
                label="Summary"
                placeholder="Brief description of the complaint..."
                [inputFormControl]="getFormControl('summary')"
                [readonly]="false"
                />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <textarea-field
                label="Description"
                placeholder="Detailed description..."
                [textareaFormControl]="getFormControl('description')"
                [readonly]="false"
                [height]="150"
                />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              @if (isLoadingFiles) {
                <loader [config]="{ overlay: false, text: 'Loading files...' }"></loader>
              }

              @if (uploadedFiles.length > 0) {
                <div class="mb-3" style="max-height: 200px; overflow-y: auto;">
                  @for (fileItem of uploadedFiles; track fileItem; let i = $index) {
                    <div class="card mb-2">
                      <div class="card-body d-flex align-items-center py-2 px-3">
                        <div class="d-flex align-items-center flex-grow-1">
                          <i class="fa fa-file text-primary me-2"></i>
                          <span>{{ fileItem.name }}</span>
                          @if (fileItem.isExisting) {
                            <span class="badge bg-success ms-2">Uploaded</span>
                          }
                          @if (!fileItem.isExisting && fileItem.file) {
                            <span class="badge bg-warning ms-2">Pending</span>
                          }
                        </div>
                        @if (fileItem.isExisting) {
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm my-1 ms-auto me-2"
                            (click)="downloadFile(fileItem)">
                            <i class="fa fa-download"></i>
                          </button>
                        }
                        <button
                          type="button"
                          class="btn btn-outline-danger btn-sm my-1"
                          [class.ms-auto]="!fileItem.isExisting"
                          (click)="confirmRemoveFile(i)"
                          [disabled]="complaintStatus === 'CLOSED'">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }

              <div class="text-start">
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="fileInput.click()"
                  [disabled]="complaintStatus === 'CLOSED'">
                  <i class="fa fa-plus"></i> {{ uploadedFiles.length > 0 ? 'Add another file' : 'Add file' }}
                </button>
                <input
                  #fileInput
                  type="file"
                  multiple
                  style="display: none"
                  (change)="onFileSelected($event)"
                  accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png"
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 col-lg-10 offset-1">
      @if (isEditPage && complaintId && !isCustomerProfile) {
        <div class="card mb-0">
          <div class="card-header bg-light font-weight-bold">STATUS</div>
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <switch-field
                  [isChecked]="isTakingCare"
                  [message]="'Taking care'"
                  [readonly]="complaintStatus === 'CLOSED' || isTakingCareSaved"
                  (valueChange)="onTakingCareChanged($event)"
                  />
              </div>
              @if (isTakingCare && assignedTo) {
                <div class="col-md-6">
                  <span class="badge bg-secondary">{{ assignedTo }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>




  <div class="row mt-4">
    <div class="col-12">
      <div class="d-flex justify-content-center gap-3">
        <button
          type="button"
          class="btn btn-outline-primary px-5"
          (click)="handleBack()">Back
        </button>
        <button
          type="button"
          class="btn btn-success btn-lg px-5"
          [disabled]="complaintStatus === 'CLOSED'"
          (click)="handleSave()">{{ isEditPage ? 'Save' : 'Send to Global Lab' }}
        </button>
      </div>
    </div>
  </div>
</form>
